function t(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch(o => setTimeout(() => {
    throw o;
  }));
}
export { t as microTask };